Hop.defineModule('footer', (root) => {
    const $targets = root.querySelectorAll('[data-target]');

    function addFooterListeners() {
        $targets.forEach((target) => {
            target.addEventListener('click', openCollapse);
        });
    }

    function openCollapse(e) {
        const element = e.target;
        const target = element.getAttribute('data-target');
        const dropdown = root.querySelector(target);

        const $icons = element.querySelectorAll('.icon');

        $icons.forEach((icon) => {
            if (icon.hidden) {
                icon.removeAttribute('hidden');
            } else {
                icon.setAttribute('hidden', true);
            }
        });

        dropdown.classList.toggle('collapse');
        dropdown.classList.toggle('in');
    }

    addFooterListeners();

    function removeFooterListeners() {
        $targets.forEach((target) => {
            target.removeEventListener('click', openCollapse);
        });
    }

    return function destroy() {
        removeFooterListeners();
    };
});
